<template lang="pug">
  .gl-create-account.gl-layout--medium-width

    // logo
    .gl-card--logo-above
      img(v-gl-wl="{ insert: 'loginLogo' }")

    // loading: config
    gl-loading-card(:options="{ message: 'Loading application', location: 'page' }" v-if="!config")

    // form
    b-form.gl-card.gl-card--form(@submit.prevent="submitForm" v-if="config" novalidate)

      // header
      .gl-card--form__header
        .gl-card--form__header__title Create Account

      // body
      .gl-card--form__body
        gl-alert(
          :options="{ errorList }"
          @clear-error-list="errorList = []")

        // Email Address
        b-form-group(:state="form.email.state" v-gl-wl="{ apply: [ 'formLabelColor', 'formLabelFontWeight' ] }" label="Email Address" label-for="email")
          b-form-input(
            :state="form.email.state"
            v-model.trim="form.email.val"
            v-gl-focus="true"
            required
            type="text")
          .invalid-feedback(v-if="form.email.invalidFeedback") {{ form.email.invalidFeedback }}

        // Password
        b-form-group(:state="form.password.state" v-gl-wl="{ apply: [ 'formLabelColor', 'formLabelFontWeight' ] }" label="Password" label-for="password")
          b-form-input(
            :state="form.password.state"
            v-model.trim="form.password.val"
            required
            type="password")
          .invalid-feedback(v-if="form.password.invalidFeedback") {{ form.password.invalidFeedback }}

        // Confirm Password
        b-form-group(:state="form.confirmedPassword.state" v-gl-wl="{ apply: [ 'formLabelColor', 'formLabelFontWeight' ] }" label="Confirm Password" label-for="confirmedPassword")
          b-form-input(
            :state="form.confirmedPassword.state"
            v-model.trim="form.confirmedPassword.val"
            required
            type="password")
          .invalid-feedback(v-if="form.confirmedPassword.invalidFeedback") {{ form.confirmedPassword.invalidFeedback }}

      // footer
      .gl-card--form__footer
        gl-btn(:options="{ label: 'Create Account', size: 'full-width', type: 'submit', style: 'brand', isLoading: isLoading.submitForm }")
        router-link.gl-card--form__footer__link(:to="{ name: 'login' }" v-gl-wl="{ apply: 'linkColor' }") Back to Sign in
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  // computed
  computed: {
    ...mapGetters(['config'])
  },

  // data
  data () {
    return {
      errorList: [],
      form: {
        email: { val: '', state: null, invalidFeedback: '' },
        password: { val: '', state: null, invalidFeedback: '' },
        confirmedPassword: { val: '', state: null, invalidFeedback: '' },
        hash: { val: '', state: null, invalidFeedback: '' }
      },
      isLoading: {
        submitForm: false
      }
    }
  },

  // methods
  methods: {
    submitForm () {
      // clear previous errors
      this.errorList = []

      // clear previous feedback
      this.$glForm.clearFeedback(this.form)

      // if form is valid
      if (this.validateForm()) {
        // start loading
        this.isLoading.submitForm = true

        // build request w/ the val attribute from each item in this.form
        let request = this.$glForm.getVals(this.form)

        // add hash to request
        request.hash = this.$route.params.hash

        // create account
        return this.$glHttp.post('user/create', request)
          .then(() => {
            // log user in
            return this.$glAuth.login(request)
          })
          .then(() => {
            // show success notification
            this.$toasted.show('Account created', {
              theme: 'primary',
              type: 'success',
              position: 'top-center',
              duration: 5000
            })

            // navigate to the dashboard
            this.$router.push('dashboard')
          })
          .catch(e => {
            // push server error
            this.errorList.push(this.$glForm.parseError(e))
          })
          .finally(() => {
            // stop loading
            this.isLoading.submitForm = false
          })
      } else {
        // focus first error
        this.$glForm.focusFirstError({ el: this.$el })
      }
    },
    validateForm () {
      // if no email -> invalid
      if (!this.form.email.val) {
        this.form.email.state = 'invalid'
        this.form.email.invalidFeedback = 'An email address is required'
      }
      // if email does not have an @ -> invalid
      if (this.form.email.val && !this.form.email.val.match(/\S+@\S+/)) {
        this.form.email.state = 'invalid'
        this.form.email.invalidFeedback = 'A valid email address is required'
      }
      // if no password -> invalid
      if (!this.form.password.val) {
        this.form.password.state = 'invalid'
        this.form.password.invalidFeedback = 'A password is required'
      }
      // if no confirmedPassword -> invalid
      if (!this.form.confirmedPassword.val) {
        this.form.confirmedPassword.state = 'invalid'
        this.form.confirmedPassword.invalidFeedback = 'A confirmed password is required'
      }
      // if passwords are supplied but do not match -> push errors
      if (this.form.password.val && this.form.confirmedPassword.val && this.form.password.val !== this.form.confirmedPassword.val) {
        this.errorList.push('Passwords do not match')
      }

      // return true if no fields are invalid
      return (this.$glForm.hasNoInvalid(this.form) && this.errorList.length === 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/CreateAccount.vue